'use strict';

import _debounce from 'lodash.debounce'

function AppRun(
  $rootScope,
  $urlRouter,
  $location,
  $window,
  $state,
  $anchorScroll,
  APP_CONSTANTS
) {

  'ngInject';

  /**
   *
   * @CONFIG
   *
   */
  if(window.location.href.includes('localhost')){
    $rootScope.apiUrlNew = APP_CONSTANTS.apiUrlLocal
    $rootScope.apiUrlBak = APP_CONSTANTS.apiUrlLocal
  }else if(window.location.href.includes('nn-www.yund.co')){
    $rootScope.apiUrlNew = APP_CONSTANTS.apiUrlNnYund;
    $rootScope.apiUrlBak = APP_CONSTANTS.apiUrlNnYund
  }else if(window.location.href.includes('frontend-prod.yund.co')){
    $rootScope.apiUrlNew = APP_CONSTANTS.apiUrlYund;
    $rootScope.apiUrlBak = APP_CONSTANTS.apiUrlYund
  }else if(window.location.href.includes('yund.co')){
    $rootScope.apiUrlNew = APP_CONSTANTS.apiUrlDev;
    $rootScope.apiUrlBak = APP_CONSTANTS.apiUrlDev
  }else if(window.location.href.includes('nowness.cn')){
    $rootScope.apiUrlNew = APP_CONSTANTS.apiUrlNowness;
    $rootScope.apiUrlBak = APP_CONSTANTS.apiUrlNowness
  }else{
    $rootScope.apiUrlNew = APP_CONSTANTS.apiUrlProd;
    $rootScope.apiUrlBak = APP_CONSTANTS.apiUrlProd
  }
  // $rootScope.apiUrlNew = (window.location.href.includes('localhost')) ? APP_CONSTANTS.apiUrlLocal : APP_CONSTANTS.apiUrlDev;
  // $rootScope.apiUrlBak = (window.location.host === 'www-nowness.bbwc.cn') ? 'https://api-nowness.bbwc.cn/api' : APP_CONSTANTS.apiUrl;
  $rootScope.s3Bucket = 'nowness-photos';
  $rootScope.appDist = $location.protocol() + '://' + $location.host() + ([443, 80].indexOf($location.port()) === -1 ? ':' + $location.port() : '');
  $rootScope.filepickerKey = 'AKkItIOgRgCOjfgcbeo7Oz';
  $rootScope.weiboKey = APP_CONSTANTS.weiboApp;
  $rootScope.doubanKey = APP_CONSTANTS.doubanApp;
  $rootScope.linkedinAppKey = APP_CONSTANTS.linkedinApp;
  $rootScope.isMobileDevice = _isMobile();
  $rootScope.chineeseTimeIncrease = 12;
  $window.prerenderReady = false;
  $rootScope.theme = null;
  $rootScope.gwiqLoaded = false;
  $rootScope.facebookSite = {
    'en-us': 'nowness',
    'zh-cn': '',
    'zh-hk': 'nownessasia',
  }
  $rootScope.twitterSite = {
    'en-us': 'nowness',
    'zh-cn': '',
    'zh-hk': 'nownessasia',
  }
  $rootScope.routing = {
    instagram: {
      'en-us': 'https://www.instagram.com/nowness/',
      'zh-cn': 'https://www.instagram.com/nowness/',
      'zh-hk': 'https://www.instagram.com/nownessasia/',
    },
    facebook: {
      'en-us': `https://www.facebook.com/${$rootScope.facebookSite['en-us']}/`,
      'zh-cn': '',
      'zh-hk': `https://www.facebook.com/${$rootScope.facebookSite['zh-hk']}/`,
    },
    twitter: {
      'en-us': `https://twitter.com/${$rootScope.twitterSite['en-us']}`,
      'zh-cn': '',
      'zh-hk': `https://twitter.com/${$rootScope.twitterSite['zh-hk']}`,
    }
  }

  /**
   *
   * @PUBLIC
   *
   */

  $rootScope.errorRedirect = function(error) {

    if (error.status === 404) {

      $location.path('/error404').replace();
    } else if (error.status === 500) {

      $location.path('/error404').replace();
    }
  };

  /**
   *
   * @PRIVATE
   *
   */

  function _handleTakeoverFakeData() {

    var body = document.body;
    var temp = document.createElement('div');
    // var logoUrl;
    // var logos;
    body.appendChild(temp);
    temp.setAttribute('id', 'takeover-fake');
    temp.className = 'takeover-fake';

    var elem = document.getElementById('takeover-fake');

    setTimeout(function() {

      // logoUrl = window.getComputedStyle(elem, null).backgroundImage.split(/"/)[1];

      $rootScope.takeoverLogoUrl = window.getComputedStyle(elem, null).backgroundImage.split(/"/)[1];

      // if (logoUrl) {
      //   logos = body.getElementsByClassName('logo-url');
      //   Object.keys(logos).forEach(function(key) {
      //     logos[key].setAttribute('href', logoUrl);
      //   });
      // }
    }, 888);
  }

  function _updateAmpTag(targetState, targetParams) {

    if (targetState && targetParams) {

      var ampBase = 'http://amp.nowness.com/story/';
      var ampStates = [
        'main.story',
        'main.picksSingle',
        'main.seriesSingle',
        'main.tagSingle'
      ];

      var show = ampStates.indexOf(targetState.name) > -1;
      var url;

      if (targetState.name === 'main.seriesSingle' || targetState.name === 'main.tagSingle') {

        show = show && !!targetParams.postSlug;

        if (show) {
          url = ampBase + targetParams.postSlug;
        }
      } else {

        url = ampBase + targetParams.slug;
      }

      $rootScope.ampTag = {
        show,
        url
      };
    }
  }

  function _isMobile() {
    var check = false;

    (function(a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|android|ipad|playbook|silk|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
        check = true;
      }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  function _initBreakpointListener () {
    const resizeHandle = _debounce(() => {
      $rootScope.isMobileDevice = _isMobile()
    }, 1000)

    window.addEventListener('resize', resizeHandle)
  }
  _initBreakpointListener()

  function _resetRoot() {

    if ($rootScope.header) {
      $rootScope.header.userNav.visible = false;
      $rootScope.header.mainNav.visible = false;
    }

    $rootScope.post = {};
    $rootScope.canonical = null;
    $rootScope.ratingsJustRatedFiveStars = false;
    $rootScope.ratingsJustRatedOneStar = false;
    $rootScope.remindMe = false;
    $rootScope.toBeLoved = false;
    $rootScope.playlistToBeLoved = false;
    $rootScope.categoryToBeFollowed = false;
    $rootScope.seriesToBeFollowed = false;
  }

  function _passTheme() {

    if ($location.search().theme) {

      $rootScope.theme = $location.search().theme;
    } else {

      var setInnerWatcherRecurrent = function() {
        var themeWatcher = $rootScope.$watch(function() {
          return $location.search().theme;
        }, function(newVal) {
          if (newVal) {
            themeWatcher();
            $rootScope.theme = newVal;
          }
        });
      };
      setInnerWatcherRecurrent();
    }
  }

  function _initEcho() {

    setTimeout(function() {

      echo.init({
        offset: 300,
        throttle: 250,
        unload: false
      });
    }, 888);
  }

  // function _includeGwiq () {
  //   const js = document.createElement('script');
  //   js.src = '//gwiqcdn.globalwebindex.net/gwiq/gwiq.js';
  //   js.type = 'text/javascript';
  //   js.async = true;

  //   js.onload = js.onreadystatechange = function () {
  //     var rs = this.readyState;
  //     if (rs && rs !== 'complete' && rs !== 'loaded') return;
  //     $rootScope.gwiqLoaded = true
  //   }

  //   var s = document.getElementsByTagName('script')[0];
  //   s.parentNode.insertBefore(js, s);
  // }

  function _gwiqTrack (toState, toParams) {
    /*
        PLAYLISTS: /playlists
        SERIES: /series
        SEASONS AND PROGRAMS: /seasons
        ART & DESIGN: /category/art-and-design
        FASHION & BEAUTY: /category/fashion-and-beauty
        MUSIC: /category/music
        FOOD & TRAVEL: /category/food-and-travel
        CULTURE: /category/culture
        TOPICS: /topics
        PICKS: /picks
        CONTRIBUTORS: /contributors
    */

    const trackedSections = ['playlists', 'series', 'seasons', 'art-and-design', 'fashion-and-beauty', 'music', 'food-and-travel', 'culture', 'topics', 'picks', 'contributors'];

    const urlArr = toState.url.split('/');
    const sectionName = urlArr[0] === 'category' ? toParams.slug : urlArr[0];

    if (trackedSections.indexOf(sectionName) === -1) return;

    if (!$rootScope.gwiqLoaded) {
      window._gwiqTrackTimeout = setTimeout(() => {
        _gwiqTrack(toState, toParams)
      }, 2000);
      return;
    }
    clearTimeout(window._gwiqTrackTimeout)

    try {
      // window.gwiq.debug = true;
      window.gwiq.track({
        cid: 'r97800j',
        site: 'nowness.com',
        section: sectionName
      });
    } catch (e) {}
  }

  // function _initGoogleAnalytics () {
  //   // jshint ignore:start
  //   if ($rootScope.lang === 'zh-hk') {

  //     // Because app is Client Side Rendered, I append analytics scripts here, to have those scripts only for .asia site.
  //     const gtagScriptEl = document.createElement('script')
  //     gtagScriptEl.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=UA-159076871-2')
  //     gtagScriptEl.setAttribute('async', 'true')
  //     document.head.appendChild(gtagScriptEl)

  //     window.dataLayer = window.dataLayer || [];
  //     function gtag(){dataLayer.push(arguments);}
  //     gtag('js', new Date());
  //     gtag('config', 'UA-159076871-2');

  //     const adSenseScriptEl = document.createElement('script')
  //     adSenseScriptEl.setAttribute('src', 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js')
  //     adSenseScriptEl.setAttribute('async', 'true')
  //     adSenseScriptEl.setAttribute('data-ad-client', 'ca-pub-9741639585006754')
  //     document.head.appendChild(adSenseScriptEl)

  //     $rootScope.$on('$locationChangeSuccess', function(e, newUrl) {
  //       const path = newUrl.split(window.location.host)[1];
  //       gtag('config', 'UA-159076871-2', {'page_path': path});
  //     })
  //   }
  //   // jshint ignore:end
  // }
  function initBaiduTongJi(){
    // console.log(_hmt,13333)
    // _hmt.push(['_trackPageview', '123']);
    // var _hmt = _hmt || [];
    // (function() {
    //   var hm = document.createElement("script");
    //   hm.src = "https://hm.baidu.com/hm.js?07a00c4beb2a9b4c49d56fadb45a745c";
    //   var s = document.getElementsByTagName("script")[0];
    //   s.parentNode.insertBefore(hm, s);
    // })();

  }

  /**
   *
   * @RUN
   *
   */

  initBaiduTongJi();
  // _initGoogleAnalytics();

  setTimeout(function() {

    $window.prerenderReady = true;
  }, 5000);

  _handleTakeoverFakeData();
  _passTheme();
  // _includeGwiq();

  $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams) {

    _handleTakeoverFakeData();
    _resetRoot();
    _updateAmpTag(toState, toParams);
    _gwiqTrack(toState, toParams);

    if (toState.name === 'main.playlistSingle') {
      $rootScope.singlePlaylistActive = true;
    } else {
      $rootScope.singlePlaylistActive = false;
    }

    _initEcho();
  });

  $rootScope.$on('$locationChangeSuccess', function(e, newUrl, oldUrl) {

    // Prevent $urlRouter's default handler from firing
    e.preventDefault();

    if ($rootScope.theme) {
      $location.search('theme', $rootScope.theme);
    }

    /*jslint laxbreak: true */
    if ($rootScope.forceRouterSync) {
      $rootScope.forceRouterSync = null;
      $urlRouter.sync();
    } else if (($state.current.name === 'main.seriesSingle' && newUrl.split(/[\/?]/)[3] === 'series' && newUrl.split(/[\/?]/)[4] === oldUrl.split(/[\/?]/)[4] && $rootScope.seriesWoot) ||
      ($state.current.name === 'main.singlePlaylist' && newUrl.split(/[\/?]/)[3] === 'playlist' && newUrl.split(/[\/?]/)[4] === oldUrl.split(/[\/?]/)[4]) ||
      ($state.current.name === 'main.member' && newUrl.split(/[\/?]/)[3] === 'member' && newUrl.split(/[\/?]/)[4] === oldUrl.split(/[\/?]/)[4]) ||
      ($state.current.name === 'main.contributorSingle' && newUrl.split(/[\/?]/)[3] === 'contributor' && newUrl.split(/[\/?]/)[4] === oldUrl.split(/[\/?]/)[4]) ||
      ($state.current.name === 'main.category' && newUrl.split(/[\/?]/)[3] === 'category' && newUrl.split(/[\/?]/)[4] === oldUrl.split(/[\/?]/)[4] && newUrl.split(/[\/?]/)[5])) {

      void 0;
    } else {
      if (!$rootScope.forceRouterToNotSync) {
        $urlRouter.sync();
      }
    }
    $rootScope.forceRouterToNotSync = false;

    if(!$rootScope.disableAnchorScroll && !$rootScope.disableAnchorScrollPreviousValue){
      $anchorScroll();
    }

    $rootScope.disableAnchorScrollPreviousValue = $rootScope.disableAnchorScroll;
    $rootScope.disableAnchorScroll = false;

    _initEcho();

    // Configures $urlRouter's listener *after* your custom listener
    $urlRouter.listen();
  });
}

export default AppRun;



// WEBPACK FOOTER //
// ./app/app.run.js